import { SelectInput } from '../../components/admin/select-input';

export const SmsMessageFilters = [
  <SelectInput
    key="status"
    source="status"
    choices={[
      { id: 'queued', name: 'Queued' },
      { id: 'sent', name: 'Sent' },
      { id: 'delivered', name: 'Delivered' },
      { id: 'failed', name: 'Failed' },
      { id: 'undelivered', name: 'Undelivered' },
      { id: 'delivery_unknown', name: 'Delivery Unknown' },
    ]}
  />,
];
